import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studySubjectPrincipleInvestigatorServices = {
  //Principle Investigator
  completeTaskSubjectForPrincipleInvestigator,
  completeBulkTaskSubjectForPrincipleInvestigator,
  sendForSubjectPrincipleInvestigator,
  getSubjectPrincipleInvestigator,
  statsSubjectPrincipleInvestigator,
  getSingleSubjectPrincipleInvestigator
};

// Send for Subject Principle Investigator
async function sendForSubjectPrincipleInvestigator(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}sendForSubjectPrincipleInvestigator`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Complete Task Subject For Principle Investigator
async function completeTaskSubjectForPrincipleInvestigator(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}completeTaskSubjectForPrincipleInvestigator`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Complete Bulk Task Subject For Principle Investigator
async function completeBulkTaskSubjectForPrincipleInvestigator(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}completeBulkTaskSubjectForPrincipleInvestigator`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Subject Principle Investigator
async function getSubjectPrincipleInvestigator(studyId, status, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSubjectPrincipleInvestigator/${studyId}/${status}/${mode}?&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSubjectPrincipleInvestigator/${studyId}/${status}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Stats Subject Principle Investigator
async function statsSubjectPrincipleInvestigator(studyId, mode) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}statsSubjectPrincipleInvestigator/${studyId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Single Subject Principle Investigator
async function getSingleSubjectPrincipleInvestigator(studyId, siteId, subjectId, mode) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleSubjectPrincipleInvestigator/${studyId}/${siteId}/${subjectId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}
